import type { InputHTMLAttributes } from 'react';

export function TextInput({ className = '', ...props }: InputHTMLAttributes<HTMLInputElement>) {
  return (
    <input
      type="text"
      className={`h-[40px] w-full rounded-[6px] border border-[rgba(60,50,47,0.12)] bg-white px-[12px] text-[14px] font-normal leading-[20px] text-content placeholder:text-content-muted focus:border-content focus:outline-none ${className}`}
      {...props}
    />
  );
}
